import styled, { keyframes } from 'styled-components';

export const ClockContainerWrap = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 6px;
  justify-content: center;
  user-select: none;
  -webkit-user-select: none;
`;

export const SegmentWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const flipTopAnimation = keyframes`
  100% {
    transform: rotateX(90deg);
  }
`;

const flipBottomAnimation = keyframes`
  100% {
    transform: rotateX(0deg);
  }
`;

export const FlipCardWrap = styled.div`
  box-sizing: border-box;
  font-family: 'Helvetica Neue', Helvetica, sans-serif;
  font-size: 22px;
  font-weight: 700;
  position: relative;
  display: inline-flex;
  flex-direction: column;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);
  border-radius: 4px;

  .top,
  .bottom,
  .top-flip,
  .bottom-flip {
    display: flex;
    justify-content: center;
    background-color: #222;
    color: white;
    overflow: hidden;
    min-width: 28px;
    width: 100%;
    height: 11px !important;
    box-shadow:
      inset 0 1px 0 rgba(255, 255, 255, 0.1),
      inset 0 -1px 0 rgba(0, 0, 0, 0.4);
  }

  .top,
  .top-flip {
    align-items: flex-start;
    padding-top: 6px;
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
  }

  .top-flip {
    position: absolute;
    left: 0;
    animation: ${flipTopAnimation} 250ms ease-in;
    transform-origin: bottom;
  }

  .bottom,
  .bottom-flip {
    align-items: flex-end;
    padding-bottom: 6px;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  .bottom-flip {
    position: absolute;
    left: 0;
    bottom: 0;
    animation: ${flipBottomAnimation} 250ms ease-out 250ms;
    transform-origin: top;
    transform: rotateX(90deg);
  }

  span {
    background-image: linear-gradient(
      180deg,
      #fff,
      ${({ $clockColor }) => $clockColor || '#fff'}
    );
    background-size: 100%;
    background-repeat: repeat;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    -moz-background-clip: text;
    -moz-text-fill-color: transparent;
  }
`;

export const DotWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  width: 8px;
  height: 35px;

  .top,
  .bottom {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: white;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  }

  .bottom {
    background-color: ${({ $dotColor }) => $dotColor || '#fff'};
  }
`;
